import type { ViewName } from '../store/types';

export interface ViewMeta {
  readonly label: string;
  readonly description: string;
}

/** 各視圖的顯示中繼資料，供工具列的視圖切換與佔位畫面共用。 */
export const VIEW_REGISTRY: Record<ViewName, ViewMeta> = {
  gantt: { label: '甘特圖', description: '任務表格 + 甘特圖，由 grid / gantt agent 接線' },
  networkDiagram: { label: '網路圖', description: '任務相依、要徑與浮時的唯讀網路圖' },
  resourceSheet: { label: '資源工作表', description: '資源清單與費率設定' },
  resourceUsage: { label: '資源使用狀況', description: '資源逐時段負載檢視' },
  costTable: { label: '成本表', description: '任務／資源成本明細' },
  projectOverview: { label: '專案總覽', description: '專案狀態、成本、資源與 EVM 摘要' },
  evmReport: { label: 'EVM 報表', description: '實獲值分析與 S 曲線' },
  reports: { label: '報表中心', description: '可設定的任務與資源表格、圖表及比較報表' },
  calendar: { label: '工作日曆', description: '每週工時、例外日與假日維護' },
  board: { label: '看板', description: '依待辦／進行中／待審核／完成分欄的任務看板' },
  timesheet: { label: '工時回報', description: '資源逐日實際工時回報與進度落後警示' },
};

export const VIEW_ORDER: readonly ViewName[] = [
  'gantt',
  'networkDiagram',
  'resourceSheet',
  'resourceUsage',
  'costTable',
  'projectOverview',
  'evmReport',
  'reports',
  'calendar',
  'board',
  'timesheet',
];
